import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Send, Copy, Share2, Loader2, Check } from "lucide-react";

export default function SendQuoteDialog({ appt, defaultEmail = "", onClose, onSent }) {
  const [email, setEmail] = useState(defaultEmail);
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!defaultEmail && appt.leadId) api.get(`/leads/${appt.leadId}`).then(({ data }) => setEmail((e) => e || data.contactInfo?.email || "")).catch(() => {}); }, [appt.leadId, defaultEmail]);

  const send = async (withEmail) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/appointments/${appt.id}/quote/send`, { origin: window.location.origin, email: withEmail ? email : "" });
      setUrl(data.url);
      onSent?.(data);
      toast.success(data.emailed ? `Devis envoyé à ${email} ✉️` : "Lien de signature prêt 🔗");
      return data.url;
    } catch (e) { toast.error(e.response?.data?.detail || "Envoi impossible"); return null; }
    finally { setBusy(false); }
  };
  const copy = async () => { const u = url || (await send(false)); if (u) { await navigator.clipboard.writeText(u).catch(() => {}); toast.success("Lien copié ✨"); } };
  const share = async () => {
    const u = url || (await send(false)); if (!u) return;
    if (navigator.share) { try { await navigator.share({ title: "Votre devis", text: `Votre devis « ${appt.title} » à signer en ligne :`, url: u }); } catch { /* cancelled */ } }
    else copy();
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="send-quote-dialog">
        <DialogHeader><DialogTitle>Envoyer pour signature</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Le client reçoit le devis en PDF et le signe en ligne. Une fois signé, il passe automatiquement en projet.</p>
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@client.fr" data-testid="send-quote-email" />
        <button onClick={() => send(true)} disabled={busy || !email.includes("@")} data-testid="send-quote-email-btn" className="h-11 rounded-xl bg-primary text-primary-foreground font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer par email
        </button>
        <div className="grid grid-cols-2 gap-2">
          <button onClick={copy} data-testid="send-quote-copy" className="h-10 rounded-xl bg-secondary text-sm font-semibold inline-flex items-center justify-center gap-1.5"><Copy className="w-4 h-4" /> Copier le lien</button>
          <button onClick={share} data-testid="send-quote-share" className="h-10 rounded-xl bg-secondary text-sm font-semibold inline-flex items-center justify-center gap-1.5"><Share2 className="w-4 h-4" /> SMS / WhatsApp</button>
        </div>
        {url && <p className="text-[11px] text-muted-foreground break-all flex items-start gap-1" data-testid="send-quote-url"><Check className="w-3.5 h-3.5 text-emerald-600 shrink-0" />{url}</p>}
      </DialogContent>
    </Dialog>
  );
}
